import Repository, {baseUrl} from "@/repositories/Repository";
import {i18n} from "@/main";

export async function addBlacklist(token, taxId, reason) {
    const endPoint = `/blacklist`;

    const formData = new FormData()
    formData.append('taxId', taxId);
    formData.append('reason', reason);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}


export async function removeBlacklist(token, taxId) {
    const endPoint = `/blacklist/remove`;

    const formData = new FormData()
    formData.append('taxId', taxId);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}

export async function updateBlacklist(token, id, reason) {
    const endPoint = `/blacklist/${id}`;

    const formData = new FormData()
    formData.append('reason', reason);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}

export async function getBlacklist(token) {
    const endPoint = `/blacklist`;


    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                if (response.data.code === 200) {
                    return response.data.blacklist;
                } else {
                    return [];
                }
            } else {
                return [];
            }
        })
        .catch(error => {

            return [];
        });
}

export async function updateVendorDeadline(token, companyFormRequestId, deadline) {
    const endPoint = `/company/form/updateDeadLine/${companyFormRequestId}?deadline=${deadline}`;

    return await Repository.put(`${baseUrl}${endPoint}`, "", {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}

export async function getVendorList(token) {
    const endPoint = `/vendors`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                if (response.data.code === 200) {
                    return response.data.vendors;
                } else {
                    return [];
                }
            } else {
                return [];
            }
        })
        .catch(error => {

            return [];
        });
}

export async function updateVendorExpiryDate(token, vendorId, expiryDate) {
    const endPoint = `/company/vendor/updateExpiryDate/${vendorId}?expiryDate=${expiryDate}`;

    return await Repository.put(`${baseUrl}${endPoint}`, "", {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {
            return {code: 1001, message: error.message};
        })
}

export async function getCustomerList(token) {
    const endPoint = `/customers`;


    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                if (response.data.code === 200) {
                    return response.data;
                } else {
                    return [];
                }
            } else {
                return [];
            }
        })
        .catch(error => {

            return [];
        });
}


export async function createForm(token, name, profileType, description, workingSector, isCalculable) {
    const endPoint = `/forms`;

    const formData = new FormData()
    formData.append('name', name);
    formData.append('profileType', profileType);
    formData.append('description', description);
    formData.append('sectors', workingSector);
    formData.append('isCalculable', isCalculable);
    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}


export async function saveForm(token, id, name, description, workingSector, calculable) {
    const endPoint = `/form/${id}`;

    const formData = new FormData()
    formData.append('name', name);
    formData.append('description', description);
    formData.append('sectors', workingSector);
    formData.append('isCalculable', calculable);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}


export async function getFormList(token) {
    const endPoint = `/forms`;


    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                if (response.data.code === 200) {
                    return response.data.forms;
                } else {
                    return [];
                }
            } else {
                return [];
            }
        })
        .catch(error => {

            return [];
        });
}

export async function copyForm(token, id, name, description) {
    const endPoint = `${baseUrl}/company/copy/companyForm/${id}?name=${name}&description=${description}`;

    return await Repository.post(endPoint, null, {
        headers: {
            token: token
        }
    })
}


export async function getFormSectorStatistics(token) {
    const endPoint = `/form/statistics`;


    return await simpleGet(token, endPoint);
}

export async function getCompanyRequestStatistics(token) {
    const endPoint = `/request/statistics`;


    return await simpleGet(token, endPoint);
}

export async function getCompanyPurchaseStatistics(token) {
    const endPoint = `/purchase/statistics`;


    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                if (response.data.code === 200) {
                    return response.data.statistics;
                } else {
                    return [];
                }
            } else {
                return [];
            }
        })
        .catch(error => {

            return [];
        });
}

export async function getMyForm(token, id, locale) {
    const endPoint = `/form/${id}`;


    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token,
            language: locale
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}


export async function createFormSection(token, formId, listOrder, name, point) {
    const endPoint = `/formSection`;

    const formData = new FormData()
    formData.append('formId', formId);
    formData.append('listOrder', listOrder);
    formData.append('title', name);
    if (point) {
        formData.append('point', point)
    }

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}


export async function saveFormSection(token, id, formId, title, listOrder, point) {
    const endPoint = `/formSection/${id}`;

    const formData = new FormData()
    formData.append('formId', formId);
    formData.append('title', title);
    formData.append('point', point);
    formData.append('listOrder', listOrder);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}


export async function createFormInput(token, formId, sectionId, inputType, title, description, listOrder, required, visible, settings, point) {
    const endPoint = `/formInput`;

    const formData = new FormData()
    formData.append('formId', formId);
    formData.append('sectionId', sectionId);
    formData.append('inputType', inputType);
    formData.append('title', title);
    formData.append('description', description);
    formData.append('listOrder', listOrder);
    formData.append('required', required ? 1 : 0);
    formData.append('visible', visible ? 1 : 0);
    formData.append('settings', JSON.stringify(settings));
    if (point) {
        formData.append('point', point);
    }

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}


export async function saveFormInput(token, id, formId, sectionId, inputType, title, description, listOrder, required, visible, settings, point) {
    const endPoint = `/formInput/${id}`;

    const formData = new FormData()
    formData.append('formId', formId);
    formData.append('sectionId', sectionId);
    formData.append('inputType', inputType);
    formData.append('title', title);
    formData.append('description', description);
    formData.append('listOrder', listOrder);
    formData.append('required', required ? 1 : 0);
    formData.append('visible', visible ? 1 : 0);
    formData.append('settings', JSON.stringify(settings));
    if (point) {
        formData.append('point', point);
    }
    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}


export async function deleteFormInput(token, id) {
    const endPoint = `/formInput/${id}/delete`;

    return await Repository.post(`${baseUrl}${endPoint}`, null, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}


export async function companyFormAction(token, id, action, reason) {
    const endPoint = `/form/${id}/${action}`;


    const formData = new FormData();
    formData.append('reason', reason);


    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}


export async function deleteFormSection(token, id) {
    const endPoint = `/formSection/${id}/delete`;

    return await Repository.post(`${baseUrl}${endPoint}`, null, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}


export async function getSectorForms(token, sectorId) {
    const endPoint = `/formsBySector/${sectorId}`;


    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                if (response.data.code === 200) {
                    return response.data.forms;
                } else {
                    return [];
                }
            } else {
                return [];
            }
        })
}

export async function getFormsBySectorIds(token, sectorIds) {
    const endPoint = `${baseUrl}/formsBySectors?sectorIds=${sectorIds.join(",")}`;
    return await Repository.get(endPoint, {
        headers: {token: token}
    }).then(response => {
        return response.data?.code === 200 ? response.data.forms : [];
    }).catch(error => {

        return [];
    });
}

export async function getProfileForms(token) {
    const endPoint = `/formsByProfile`;


    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                if (response.data.code === 200) {
                    return response.data.forms;
                } else {
                    return [];
                }
            } else {
                return [];
            }
        })
        .catch(error => {
            return [];
        });
}


export async function getCompanyForms(token, companyId) {
    const endPoint = `/formsByCompany/${companyId}`;


    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                if (response.data.code === 200) {
                    return {
                        forms: response.data.forms,
                        my_requests: response.data.my_requests,
                        company: response.data.company
                    };
                } else {
                    return {forms: [], company: null};
                }
            } else {
                return {forms: [], company: null};
            }
        })
        .catch(error => {
            return {forms: [], company: null};
        });
}


export async function getOfflineForm(id, locale, company) {
    let endPoint;
    if (company) {
        endPoint = `/offline/form/${id}?companyId=${company.id}`;
    } else {
        endPoint = `/offline/form/${id}`;
    }


    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {

            language: locale
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}


export async function saveFormRequest(token, formId, requestBody, sectors) {
    const endPoint = `/forms/${formId}/request`;
    const formData = new FormData()
    formData.append('requestBody', requestBody);
    formData.append('sectors', sectors);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}

export async function updateFormRequest(token, requestId, requestBody, sectors) {
    const endPoint = `/formRequest/${requestId}/update`;

    const formData = new FormData();
    formData.append('requestBody', requestBody);
    formData.append('sectors', sectors);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}


export async function sendFormRequestForApproval(token, requestId) {
    const endPoint = `/formRequest/${requestId}/send`;


    return await Repository.post(`${baseUrl}${endPoint}`, null, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}

export async function sendFormRequestReady(token, requestId) {
    const endPoint = `/formRequest/${requestId}/ready`;


    return await Repository.post(`${baseUrl}${endPoint}`, null, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}


export async function getFormOutgoingRequests(token, id) {
    let endPoint = `/formRequest/outGoing`;

    if (id > 0) {
        endPoint += '?formId=' + id;
    }

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token,
            'language': i18n.locale
        }
    })
        .then(response => {
            if (response.data) {
                if (response.data.code === 200) {
                    return response.data.forms;
                } else {
                    return [];
                }
            } else {
                return [];
            }
        })
        .catch(error => {

            return [];
        });
}

export async function getFormRequestById(token, requestId) {
    let endPoint = `/formRequest/${requestId}`;


    return await simpleGet(token, endPoint);
}

export async function getFormRequestByIdReceiver(token, requestId) {
    let endPoint = `/formRequest/${requestId}/details`;


    return await simpleGet(token, endPoint);
}


export async function getFormRequestMessages(token, requestId) {
    let endPoint = `/formRequest/${requestId}/messages`;

    return await simpleGet(token, endPoint);
}


export async function getFormIncomingRequests(token, id) {
    let endPoint = `/formRequest/inComing`;

    if (id > 0) {
        endPoint += '?formId=' + id;
    }


    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                if (response.data.code === 200) {
                    return response.data.forms;
                } else {
                    return [];
                }
            } else {
                return [];
            }
        })
        .catch(error => {

            return [];
        });
}


export async function returnRequest(token, requestId, reason) {
    const endPoint = `/formRequest/${requestId}/return`;


    const formData = new FormData();
    formData.append('reason', reason);


    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}

export async function rejectRequest(token, requestId, reason) {
    const endPoint = `/formRequest/${requestId}/reject`;


    const formData = new FormData();
    formData.append('reason', reason);


    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}

export async function recallRequest(token, requestId, reason) {
    const endPoint = `/formRequest/${requestId}/recall`;


    const formData = new FormData();
    formData.append('reason', reason);


    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}

export async function approveRequest(token, requestId, sectors) {
    const endPoint = `/formRequest/${requestId}/approve`;


    const formData = new FormData();
    formData.append('sectors', sectors);


    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}


export async function exportRequest(token, requestId, format) {
    const endPoint = `/formRequest/${requestId}/export?format=${format}`;


    return await simpleGet(token, endPoint);
}

export async function exportRequestNew(token, requestId, format) {
    const endPoint = `/company/vendor/generate/${requestId}?format=${format}`;


    return await simpleGet(token, endPoint);
}

export async function sendMessage(token, requestId, message) {
    const endPoint = `/formRequest/${requestId}/comment`;


    const formData = new FormData();
    formData.append('comment', message);


    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}


export async function closeConversation(token, requestId) {
    const endPoint = `/formRequest/${requestId}/endConversation`;

    return await Repository.post(`${baseUrl}${endPoint}`, null, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}


export async function getFormFaq(token, id) {
    const endPoint = `/forms/${id}/faqList`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                if (response.data.code === 200) {
                    return response.data.faq;
                } else {
                    return [];
                }
            } else {
                return [];
            }
        })
        .catch(error => {

            return [];
        });
}


export async function askFaqQuestion(token, formId, question) {
    const endPoint = `/forms/${formId}/ask`;

    const formData = new FormData()
    formData.append('question', question);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}

export async function editFaqQuestion(token, faqId, question) {
    const endPoint = `/forms/${faqId}/editFaq`;

    const formData = new FormData()
    formData.append('question', question);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}

export async function answerFaqQuestion(token, faqId, answer) {
    const endPoint = `/forms/${faqId}/answerFaq`;

    const formData = new FormData()
    formData.append('answer', answer);
    formData.append('attachment', '');

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}

export async function rejectFaqQuestion(token, faqId, reason) {
    const endPoint = `/forms/${faqId}/rejectFaq`;

    const formData = new FormData()
    formData.append('reason', reason);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}


export async function getCompanyRequestDynamics(token, sectorId, startDate, endDate, status, type) {
    const endPoint = `/request/dynamics?sectorId=${sectorId}&startDate=${startDate}&endDate=${endDate}&requestStatus=${status}&requestType=${type}`;


    return await simpleGet(token, endPoint);
}

export async function searchCompanyByNameOrTaxId(
    token, name, taxId
) {
    const endPoint = `/company/search/new?name=${name}&taxId=${taxId}`;
    return await simpleGet(token, endPoint);
}

export async function sendNotification(token, companyId, formId, vendorCompanyId) {
    const endPoint = `/company/form/sendNotify?companyId=${companyId}&companyFormId=${formId}&vendorCompanyId=${vendorCompanyId}`;
    return await Repository.post(`${baseUrl}${endPoint}`, null, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {

                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}

export async function addCompanyToVendorManagment(token, companyId, profileType, sectors) {
    const endPoint = `/addCompanyToVendorList/${companyId}/${profileType}`;
    const formData = new FormData()
    formData.append('sectors', sectors);
    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}


export async function getCompanyRequestStatusReport(token, startDate, endDate, status, type, success) {
    const endPoint = `/request/statusReport?startDate=${startDate}&endDate=${endDate}&requestStatus=${status}&requestType=${type}&requestSuccess=${success}`;


    return await simpleGet(token, endPoint);
}

export async function getCompanyPurchaseReport(token, sectorId, startDate, endDate, status, success, type) {
    const endPoint = `/request/purchases?sectorId=${sectorId}&startDate=${startDate}&endDate=${endDate}&requestStatus=${status}&requestSuccess=${success}&requestType=${type}`;


    return await simpleGet(token, endPoint);
}

// Retrieve the list of deleted vendors for the current company
export async function getDeletedVendors(token) {
    const endPoint = `/deleted-vendors`;

    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                if (response.data.code === 200) {
                    return response.data.deletedVendors;
                } else {
                    return [];
                }
            } else {
                return [];
            }
        })
        .catch(error => {

            return [];
        });
}

// Add a company to the deleted vendors list
export async function addDeletedVendor(token, taxId, reason) {
    const endPoint = `/deleted-vendors`;

    const formData = new FormData();
    formData.append('taxId', taxId);
    formData.append('reason', reason);

    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}

// Delete a company from the deleted vendors list by tax ID
export async function deleteDeletedVendor(token, taxId) {
    const endPoint = `/deleted-vendors/${taxId}`;


    return await Repository.delete(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}

// Update the reason for deleting a company in the deleted vendors list
export async function updateDeletedVendor(token, id, reason) {
    const endPoint = `/deleted-vendors/${id}`;

    const formData = new FormData();
    formData.append('reason', reason);

    return await Repository.putForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}

export async function getProcurementProfiles(token, companyId) {
    const endPoint = `/company/procurement-accounts/${companyId}`;
    return await simpleGet(token, endPoint);
}

export async function getConfirmationList(token, companyFormRequestId) {
    const endPoint = `/company/order-profiles/${companyFormRequestId}`;
    return await simpleGet(token, endPoint);
}

export async function sendCompanyProfileOrder(token, companyFormRequestId, selectedProfiles) {
    const endPoint = `/company/order-profile/create`;
    // Initialize FormData
    const formData = new FormData();
    formData.append('companyFormRequestId', companyFormRequestId);

    // Append each profile with indexed keys
    selectedProfiles.forEach((profile, index) => {
        formData.append(`orders[${index}].companyUserId`, profile.companyUserId);
        formData.append(`orders[${index}].order`, index + 1); // 1-based indexing
        formData.append(`orders[${index}].status`, 'WAITING'); // Adjust status as needed
    });

    // Send Request
    return await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}

export async function changeStatusCompanyProfileOrder(token, orderId, status, rejectReason) {
    const endPoint = `/company/order-profile/update/${orderId}?status=${status}&rejectReason=${rejectReason}`;
    return await simpleGet(token, endPoint);
}

export async function simpleGet(token, endPoint) {
    return await Repository.get(`${baseUrl}${endPoint}`, {
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.data) {
                return response.data;
            } else {
                return {code: 1000, message: response.statusText};
            }
        })
        .catch(error => {

            return {code: 1001, message: error.message};
        });
}

export function handleErrors($swal, {code, message, errorCode}, next) {

    if (errorCode) {

        switch (errorCode) {
            case 'personal_account':
                $swal({
                    title: i18n.t("generalModal.warningTitle"),
                    text: i18n.t("buFnksyfrdSrktlrAktvDyl"),
                    icon: 'warning'
                }).then(() => {
                    if (next) {
                        next();
                    }
                });
                break;
            case 'not_procurement':
                $swal({
                    title: i18n.t("generalModal.warningTitle"),
                    text: i18n.t("buFnksyYlnzStnlmcPrfl"),
                    icon: 'warning'
                }).then(() => {
                    if (next) {
                        next();
                    }
                });
                break;
            case 'not_supplier':
                $swal({
                    title: i18n.t("generalModal.warningTitle"),
                    text: i18n.t(("buFnksyYlnzTdrkcPrfl")),
                    icon: 'warning'
                }).then(() => {
                    if (next) {
                        next();
                    }
                });
                break;

            case 'not_allowed_profile':
                $swal({
                    title: i18n.t("generalModal.warningTitle"),
                    text: i18n.t("buFnksySznPrflnzdKtvDyl"),
                    icon: 'warning'
                }).then(() => {
                    if (next) {
                        next();
                    }
                });
                break;

            case 'you_are_not_admin':
                $swal({
                    title: i18n.t("generalModal.warningTitle"),
                    text: i18n.t("sizSrktnAdmnDylsnz"),
                    icon: 'warning'
                }).then(() => {
                    if (next) {
                        next();
                    }
                });
                break;
            case 'company_admin_missing':
            case 'company_does_not_have_admin':
                $swal({
                    title: i18n.t("generalModal.warningTitle"),
                    text: i18n.t("buFnksydnIstfdBlmkSrktnzAdmn"),
                    icon: 'warning'
                }).then(() => {
                    if (next) {
                        next();
                    }
                });
                break;

            case 'profile_not_verified':
            case 'company_user_not_confirmed':
                $swal({
                    title: i18n.t("generalModal.warningTitle"),
                    text: i18n.t("buFnksydnIstfdBlmkSrkntnznAmdini"),
                    icon: 'warning'
                }).then(() => {
                    if (next) {
                        next();
                    }
                });
                break;

            case 'can_not_ask_own_company':
                $swal({
                    title: i18n.t("generalModal.warningTitle"),
                    text: i18n.t(("ozSrktnznFrmsnSualGndrBlmsnz")),
                    icon: 'warning'
                }).then(() => {
                    if (next) {
                        next();
                    }
                });
                break;
            case 'can_not_request_own_company':
                $swal({
                    title: i18n.t("generalModal.warningTitle"),
                    text: i18n.t("ozSrktnznFrmsnMrctGndrBlmsnz"),
                    icon: 'warning'
                }).then(() => {
                    if (next) {
                        next();
                    }
                });
                break;
            case 'status_not_allowed':
                $swal({
                    title: i18n.t("generalModal.warningTitle"),
                    text: i18n.t(("mvcdSttsndCrEmliyyt")),
                    icon: 'warning'
                }).then(() => {
                    if (next) {
                        next();
                    }
                });
                break;
            case 'not_your_question':
                $swal({
                    title: i18n.t("generalModal.warningTitle"),
                    text: i18n.t("szOznzAidOlmynSualDys"),
                    icon: 'warning'
                }).then(() => {
                    if (next) {
                        next();
                    }
                });
                break;
            case 'conversation_closed':
                $swal({
                    title: i18n.t("generalModal.warningTitle"),
                    text: i18n.t("mzkrStnlmcTrfndnBglnmdr"),
                    icon: 'warning'
                }).then(() => {
                    if (next) {
                        next();
                    }
                });
                break;
            case 'company_user_does_not_exists':
                $swal({
                    title: i18n.t("generalModal.warningTitle"),
                    text: i18n.t("sznPrflnzAktvDyl"),
                    icon: 'warning'
                }).then(() => {
                    if (next) {
                        next();
                    }
                });
                break;
            case 'not_package':
                $swal({
                    title: i18n.t("generalModal.warningTitle"),
                    text: i18n.t("aktvlsdrmkIstdynzFrdPktDyl"),
                    icon: 'warning'
                }).then(() => {
                    if (next) {
                        next();
                    }
                });
                break;
            case 'not_addon':
                $swal({
                    title: i18n.t("generalModal.warningTitle"),
                    text: i18n.t("aktvlsdrmkIstdynzSrktElaveDyl"),
                    icon: 'warning'
                }).then(() => {
                    if (next) {
                        next();
                    }
                });
                break;
            case 'user_package_not_active':
                $swal({
                    title: i18n.t("generalModal.warningTitle"),
                    text: i18n.t("buPktAktvDyl"),
                    icon: 'warning'
                }).then(() => {
                    if (next) {
                        next();
                    }
                });
                break;
            case 'package_not_canceled':
                $swal({
                    title: i18n.t("generalModal.warningTitle"),
                    text: i18n.t("buPktLgvEdlmyb"),
                    icon: 'warning'
                }).then(() => {
                    if (next) {
                        next();
                    }
                });
                break;
            case 'only_admins':
                $swal({
                    title: i18n.t("generalModal.warningTitle"),
                    text: i18n.t("buEmlyytYlnzSrktIdrclr"),
                    icon: 'warning'
                }).then(() => {
                    if (next) {
                        next();
                    }
                });
                break;
            case 'form_request_already_sent':
                $swal({
                    title: i18n.t("generalModal.warningTitle"),
                    text: i18n.t("sizArtqBuDyrlndrmFrmsMrctEtmsnz"),
                    icon: 'warning'
                }).then(() => {
                    if (next) {
                        next();
                    }
                });
                break;
            default:
                $swal({
                    title: `Xəta ${code}!`,
                    text: `${message}: ${errorCode}`,
                    icon: 'error'
                }).then(() => {
                    if (next) {
                        next();
                    }
                });
        }

    } else if (code === 404) {
        $swal({
            title: this.$t("general.notFound"),
            text: this.$t("axtrdgnzFrmTpldm"),
            icon: 'error'
        }).then(() => {
            if (next) {
                next();
            }
        });
    } else if (code === 409) {
        $swal({
            title: i18n.t("generalModal.warningTitle"),
            text: i18n.t("buElmntArtqMvcddr"),
            icon: 'error'
        }).then(() => {
            if (next) {
                next();
            }
        });
    } else if (code === 1000 || code === 1001) {
        $swal({
            title: i18n.t("generalModal.warningTitle"),
            text: i18n.t("gzlnlmzXtBsVrd", {message: message}),
            icon: 'error'
        }).then(() => {
            if (next) {
                next();
            }
        });
    } else {
        $swal({
            title: `Error ${code}`,
            text: `${message}`,
            icon: 'error'
        }).then(() => {
            if (next) {
                next();
            }
        });
    }

}